import styled from 'styled-components';

export const UserNameAndImageStyled = styled.div<{ isExpired?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 1px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) =>
    props.isExpired
      ? props.theme.atlas.semantic.color.status.warning.default
      : props.theme.atlas.semantic.color.type.default};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.01em;
  align-items: center;
`;

export const UserImage = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;
